module.exports = __webpack_public_path__ + "static/media/F-4.25d98cfc.webp";